import React from "react";
import CopyIcon from "@atlaskit/icon/glyph/copy";

import { Button } from "../../UI/Button";
import { useUserContext } from "../../contexts/UserContext";
import { copyToClipboard } from "../../helpers/copyToClipboard";
import { useSnackbar } from "../../hooks/useSnackbar";

export const CopyRoommatesButton = () => {
  const { user } = useUserContext();
  const { showSuccessSnackbar } = useSnackbar();

  const roommates = user?.roommates || [];

  const handleCopyClick = () => {
    const roommatesList = roommates
      .map((roommate) => `${roommate.firstName} ${roommate.lastName}`)
      .join("\n");
    copyToClipboard(roommatesList);
    showSuccessSnackbar("Roommates copied to clipboard");
  };

  if (!roommates.length) {
    return null;
  }

  return (
    <Button
      appearance="primary"
      iconBefore={<CopyIcon label="copy" />}
      onClick={handleCopyClick}
    >
      Copy Roommates
    </Button>
  );
};

